import React, { useCallback, useEffect, useRef, useState } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useTheme } from '@emotion/react';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import NumberInput from '../Input/NumberInput';
import ButtonAction from '../Button.js/SaveButton';
import TextInput from '../Input/TextInput';
import ComboBox from '../Input/ComboBox';
import { debounce } from 'lodash';
import { sendRequest, serviceList } from 'src/utils';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};
const ChangeUserTake = ({
    visible = false,
    callBackFunct,
    product,
    setVisible,
    setnote,
    note,
    setQuantity,
    quantity,
    isRegisterOnline = false,
    userHelper,
}) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const quantityRef = useRef(null);
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

    const [dataUsers, setDataUsers] = useState([]);
    const getRefUser = useRef(false);
    const [getFlagsUser, setGetFlagsUser] = useState(false);
    const searchValueDeboun = useRef('');
    const throttled = useRef(debounce(() => getDataUsers(), 1000));
    const [getValueUser, setGetValueUser] = useState('');

    useEffect(() => {
        quantityRef.current?.focus();
        if (isRegisterOnline) {
            setTimeout(() => {
                getDataUsers();
            }, 1000);
        }
    }, []);

    useEffect(() => {
        if (userHelper) {
            searchValueDeboun.current = dataUsers.find((ele) => ele.id === userHelper);
            setGetValueUser(dataUsers.find((ele) => ele.id === userHelper));
        }
    }, [visible]);

    const getDataUsers = useCallback(() => {
        if (getRefUser.current) {
            return;
        }
        getRefUser.current = true;
        setGetFlagsUser(true);
        const InVal = [0, (searchValueDeboun?.current || '')?.toUpperCase()];
        sendRequest(serviceList.getAllstaff, InVal, getDataResultUsers, true, timeOutFunctUsers, 40000);
    }, []);

    const getDataResultUsers = (reqInfoMap, message) => {
        getRefUser.current = false;
        setGetFlagsUser(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error 2: ' + message['proc_message']);
            return;
        } else {
            let data = message.proc_data.rows[0].o_1;
            const newData = data.map((item) => ({
                ...item,
                search: item.user_nm + ` - ${t('department').toLocaleLowerCase()}: ` + item.departs_nm,
            }));
            setDataUsers([...newData]);
        }
    };

    const timeOutFunctUsers = (reqInfo) => {
        getRefUser.current = false;
        setGetFlagsUser(false);
        toast.error(t('error.time_out'));
    };

    const searchValue = (value) => {
        if (!value) {
            value = '';
        }
        searchValueDeboun.current = value;
        // setvalueSearch(value);
        throttled.current();
    };

    const handleClick = () => {
        // console.log('handleClick', product, +quantity, note, searchValueDeboun.current);
        if (!note) {
            // noteRef.current.focus();
            return toast.error(t('enter_note'));
        }
        if (!quantity || +quantity < 1) {
            return toast.error(t('enter_quantity'));
        }
        // setVisible(false);
        setTimeout(() => setVisible(false), 50);
        callBackFunct && callBackFunct(product, +quantity, note, searchValueDeboun.current);
        setnote('');
        setQuantity('1');
    };

    return (
        <BootstrapDialog
            fullScreen={fullScreen}
            open={visible}
            aria-labelledby="customized-dialog-title"
            PaperProps={{ component: 'div' }}
        >
            <BootstrapDialogTitle
                onClose={() => {
                    setVisible(!visible);
                }}
                id="customized-dialog-title"
            >
                {t('update_category')}
            </BootstrapDialogTitle>
            <DialogContent dividers>
                <Grid container spacing={2}>
                    <Grid item style={{ width: '100%' }} xl={6} md={6} sm={6}>
                        <NumberInput
                            label={t('quantity_category')}
                            valueChange={quantity}
                            size="medium"
                            // autoFocus
                            required
                            onEnterPress={handleClick}
                            // ref={quantityRef}
                            getValue={setQuantity}
                        />
                    </Grid>
                    <Grid item style={{ width: '100%' }} xl={6} md={6} sm={6}>
                        <TextInput
                            // ref={noteRef}
                            size="medium"
                            label={t('note_')}
                            valueChange={note}
                            onEnterPress={handleClick}
                            required
                            placeholder={t('note_add_caterory')}
                            getValue={setnote}
                            autoFocus
                        />
                    </Grid>
                    {isRegisterOnline && (
                        <Grid item xl={12} md={12} sm={12} style={{ width: '100%' }}>
                            <ComboBox
                                label={t('helper_name_device')}
                                selectOption={dataUsers}
                                displayLabel="search"
                                valueSelect={getValueUser}
                                getValue={searchValue}
                            />
                        </Grid>
                    )}
                </Grid>
            </DialogContent>
            <DialogActions style={{ padding: '12px 16px' }}>
                <ButtonAction
                    onClick={() => {
                        setVisible(!visible);
                    }}
                    type={'cancel'}
                    title={t('cancel')}
                />
                <ButtonAction onClick={handleClick} type={'export'} title={t('comfirm')} />
            </DialogActions>
        </BootstrapDialog>
    );
};

export default ChangeUserTake;
